import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { batchActions } from "@obg/ngrx-utils";
import { AppContextSelector, CoreState, ProductType } from "@obg/ngx.core";
import { RouteAction, RouteConfig } from "@obg/ngx.router";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";

import { ProductMappingService } from "../product-mapping/product-mapping.service";

@Injectable({
	providedIn: "root",
})
export class ProductDetectionGuard implements CanActivate {
	previousLobby: string | undefined;

	constructor(
		private store: Store<CoreState>,
		private router: Router,
		private productMappingService: ProductMappingService
	) {}

	canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
		if (route.queryParams && route.queryParams.product) {
			return of(true);
		}

		const currentNavigation = this.router.getCurrentNavigation();
		const extras = currentNavigation ? currentNavigation.extras : undefined;

		return this.store.select(AppContextSelector.getProduct).pipe(
			tap((currentProduct) => {
				if (!this.previousLobby || this.previousLobby === ProductType.Common) {
					this.previousLobby = this.productMappingService.getMappedProduct(currentProduct);
				}

				const { name } = route.routeConfig as RouteConfig;
				this.store.dispatch(
					batchActions(
						RouteAction.navigate(name, undefined, {
							...extras,
							queryParams: {
								...route.queryParams,
								product: this.previousLobby || ProductType.Common,
							},
						})
					)
				);
			}),
			map(() => false)
		);
	}
}
